import React from "react";
import {
  Modal,
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
} from "react-native";
import { Colors } from "@/constants/Colors";
import { FontFamilies } from "@/constants/Typography";

type Props = {
  visible: boolean;
  onCallAnyway: () => void;
  onCancel: () => void;
};

const { width } = Dimensions.get("window");

export const OfficeHoursModal: React.FC<Props> = ({
  visible,
  onCallAnyway,
  onCancel,
}) => {
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onCancel}
    >
      <View style={styles.overlay}>
        <View style={styles.modal}>
          <Text style={styles.title}>Outside Business Hours</Text>
          <Text style={styles.message}>
            You&apos;re calling outside typical business hours. You&apos;ll
            likely reach an automated system, which has a lower success rate for
            refunds.
          </Text>
          <Text style={styles.suggestion}>
            For best results, try calling Monday-Friday between 9 AM - 6 PM.
          </Text>

          <TouchableOpacity
            style={styles.primaryButton}
            onPress={onCallAnyway}
            activeOpacity={0.8}
          >
            <Text style={styles.primaryButtonText}>Call Anyway</Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.secondaryButton}
            onPress={onCancel}
            activeOpacity={0.8}
          >
            <Text style={styles.secondaryButtonText}>Cancel</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  modal: {
    backgroundColor: Colors.white,
    borderRadius: 16,
    padding: 24,
    width: width - 40,
    maxWidth: 400,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 8,
  },
  title: {
    fontSize: 20,
    fontFamily: FontFamilies.Inter.SemiBold,
    color: Colors.text,
    marginBottom: 12,
    textAlign: "center",
  },
  message: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Regular,
    color: Colors.text,
    lineHeight: 22,
    marginBottom: 12,
    textAlign: "center",
  },
  suggestion: {
    fontSize: 14,
    fontFamily: FontFamilies.Inter.Medium,
    color: Colors.primary,
    lineHeight: 20,
    marginBottom: 24,
    textAlign: "center",
  },
  primaryButton: {
    backgroundColor: Colors.primary,
    borderRadius: 100,
    paddingVertical: 16,
    paddingHorizontal: 20,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 12,
  },
  primaryButtonText: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 17,
    color: Colors.white,
  },
  secondaryButton: {
    backgroundColor: "transparent",
    borderRadius: 100,
    paddingVertical: 16,
    paddingHorizontal: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  secondaryButtonText: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 15,
    color: "#414141",
  },
});
